module.exports = __webpack_public_path__ + "static/img/saimenInstallForMac_pic10.8cd84f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForMac/saimenInstallForMac_pic10.png
// module id = 561
// module chunks = 1